import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { View } from 'react-native';

import { FieldBlock } from '@/components/services/wizard/field';
import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import { paymentMethodOptions } from '@/constants/service-payment-methods';
import type { ServiceFormData } from '@/lib/validators/service';
import { cn } from '@/utils/cn';

interface Props {
  control: Control<ServiceFormData>;
}

/**
 * Formas de pagamento em chips: escolha múltipla curta, sem abrir select.
 */
export function PaymentMethodsField({ control }: Props) {
  return (
    <Controller
      control={control}
      name="allowedPaymentMethods"
      render={({ field, fieldState }) => {
        const selected: string[] = field.value ?? [];

        return (
          <FieldBlock
            title="Como você aceita pagamento"
            error={fieldState.error?.message}
          >
            <View className="flex-row flex-wrap gap-2">
              {paymentMethodOptions.map((option) => {
                const active = selected.includes(option.value);
                return (
                  <PressableScale
                    key={option.value}
                    haptic
                    accessibilityRole="button"
                    accessibilityState={{ selected: active }}
                    onPress={() =>
                      field.onChange(
                        active
                          ? selected.filter((item) => item !== option.value)
                          : [...selected, option.value],
                      )
                    }
                    className={cn(
                      'h-10 items-center justify-center rounded-full px-4',
                      active ? 'bg-primary' : 'bg-neutral-100',
                    )}
                    style={{ borderCurve: 'continuous' }}
                  >
                    <ThemedText
                      className={cn(
                        'text-[13px] font-semibold',
                        active ? 'text-primary-foreground' : 'text-neutral-700',
                      )}
                    >
                      {option.label}
                    </ThemedText>
                  </PressableScale>
                );
              })}
            </View>
          </FieldBlock>
        );
      }}
    />
  );
}
